import { InviteStatus } from '@shared/invite/enums';

export const InviteStatusesMap = {
  [InviteStatus.expired]: 'Expired',
  [InviteStatus.declined]: 'Declined',
  [InviteStatus.pending]: 'Pending',
};
